import { Button, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { notifications } from "@mantine/notifications";
import type { JSX } from "react";
import { useMutation } from "urql";
import { deleteMutation, type TranscriptionDeleteMutation, type TranscriptionDeleteMutationVariables } from "./queries";

interface IProps {
    transcription: {
        id: number;
    };
}

function DeleteButton({ transcription }: IProps): JSX.Element {
    const [deleteResult, executeDelete] = useMutation<
        TranscriptionDeleteMutation,
        TranscriptionDeleteMutationVariables
    >(deleteMutation);

    const doDelete = async () => {
        const result = await executeDelete({ transcriptionId: transcription.id });
        if (result.error) {
            notifications.show({
                title: "Failed to delete Transcription",
                message: result.error.message,
            });
        } else {
            notifications.show({
                title: "Transcription deleted",
                message: "Transcription deleted",
            });
        }
    };

    const onClick = () =>
        modals.openConfirmModal({
            title: "Delete Transcription?",
            children: <Text size="sm">Are you sure you want to delete the transcription?</Text>,
            labels: { confirm: "Confirm", cancel: "Cancel" },
            onConfirm: doDelete,
            confirmProps: { color: "red" },
        });

    return (
        <Button onClick={onClick} disabled={deleteResult.fetching} color="red">
            Delete
        </Button>
    );
}

export default DeleteButton;
